module.exports = __webpack_public_path__ + "media/images/Tap-b4cc174e7391331a13be9b689a98b9b5.png";